import api from "@/api/client";

const MEET_URL = import.meta.env.VITE_MEET_URL || "https://meet.studox.eu";

/**
 * Open StudoX Meet from inside Flow WITHOUT a second login. Mints a short-lived
 * SSO nonce from the shared backend (the same handoff Core uses) and lands on
 * meet.studox.eu?sso=…, which exchanges it for the shared session. Falls back
 * to a plain open if the mint hiccups (Meet's own gate then adopts the shared
 * token or bounces cleanly to Core).
 */
export async function launchMeet() {
  try {
    const { data } = await api.post("/auth/sso-token", {}); // no per-app gate — Meet is base comms
    window.location.href = data?.token ? `${MEET_URL}?sso=${encodeURIComponent(data.token)}` : MEET_URL;
  } catch {
    window.location.href = MEET_URL;
  }
}
